import type { FormulaNode } from "../../customMeasure/utilities/fillNodes";
import type {
  ChartOfAccountsItem,
  ConditionField,
  DimensionDictionary,
} from "../../../../../../../../../api/types/svTypes.ts";

export function getFilterUniqueId(index: number, condition: ConditionField, parentId: string | undefined) {
  return `${parentId || ""}-${index}-${condition.meta.name}`;
}

export function getVariablePropertyItemUniqueId(index: number, fn: FormulaNode, parentId: string | undefined) {
  return `${parentId || ""}${index}-var-${fn.key}`;
}

export function getFilterFieldSubItemUniqueId(item: DimensionDictionary, parentId: string | undefined) {
  return `${parentId || ""}-${Object.values(item).join("-")}`;
}

export function getChartOfAccountUniqueId(index: number, item: ChartOfAccountsItem, parentId: string | undefined) {
  return `${parentId || ""}-${index}-${Object.values(item).join("-")}`;
}

export function getFunctionPropertyItemUniqueId(index: number, fn: FormulaNode) {
  return `${index}-fn-${fn.key}`;
}
